<div class="modal topup-modal">
  <div class="container model-container">
    <div class="modal-header">
      <img src="assets/icon/primary-close.svg" (click)="closeDialog(false)" class="modal-close" width="28" height="28"
        alt="Close Icon">
    </div>
    <div>
      <app-top-up-card [specificTitle]="data.title" [noteDesc]="data.description" [verificationRequired]="true"></app-top-up-card>
    </div>
  </div>
</div>
